import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Cashier/Waiter", key: "waiter" },
  { label: "Latest Date", key: "latest_date", render: (row) => String(row.latest_date || "--------").slice(0, 10) },
  { label: "Table Count", key: "table_count" },
  { label: "Customers", key: "total_customers" },
  { label: "Total Bills", key: "total_bills" },
  { label: "Void Bills", key: "void_bills" },
  { label: "Cash Income(Rs.)", key: "cash_income", render: (row) => Number(row.cash_income || 0).toFixed(2) },
  { label: "Card Income(Rs.)", key: "card_income", render: (row) => Number(row.card_income || 0).toFixed(2) },
  { label: "UPI Income(Rs.)", key: "upi_income", render: (row) => Number(row.upi_income || 0).toFixed(2) },
  { label: "Total Income(Rs.)", key: "total_income", render: (row) => Number(row.total_income || 0).toFixed(2) },
];

const CashierWaiterReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No cashier/waiter report data found."
  />
);

export default CashierWaiterReport;
